import client from '../client';
import { toInteger } from 'lodash';
import { OrderCategory } from "./Order";

export type TApiProvider = {
  id: number;
  name: string;
  logo: string;
}

export type TProviderListParams = {}

const list = (params?: TProviderListParams): Promise<Array<TApiProvider>> =>
  client.get('/ccp/', {
    params
  }).then(response => response.data);

export {
  list
};
